<div>
    <h1>{{'rm.erp.jobapplication.success.title' | hisUi }}</h1>
    <br>

    <div [innerHTML]="getSuccessBodyText()"></div>

    <br>

    <div>{{ jobApplicationDto.message }}</div>
</div>
